import React from "react";

function Wrapper({ children }) {
  return (
    <div className="w-full px-5 sm:px-8 lg:px-12 mx-auto">
      {children}
    </div>
  );
}

export default Wrapper;
